// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"c80fc6f1b2388723d7a5","223":"ddd533abe5b4b2c387d6","293":"e40d625e163895e7e130"}[chunkId] + ".js";
};